import registerServiceWorker from './registerServiceWorker';
import boot from './components'

registerServiceWorker();
boot();
